module.exports = __webpack_public_path__ + "img/3.48df756e.jpg";